/* ═══════════════════════════════════════════════
   PAWTASTIC DEALS — THEME JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initCart();
  initProductFilters();
  initFadeObserver();
  initMobileMenu();
});

/* ── Header scroll behaviour ── */
function initHeader() {
  const header = document.getElementById('site-header');
  if (!header) return;
  const isTransparent = header.dataset.transparent === 'true';

  function update() {
    if (isTransparent) {
      header.classList.toggle('scrolled', window.scrollY > 50);
    } else {
      header.classList.add('scrolled');
    }
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
}

/* ── Mobile menu ── */
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const btn  = document.getElementById('mobile-menu-btn');
  if (!menu) return;
  menu.classList.toggle('open');
  btn?.classList.toggle('open');
}

function toggleSearch() {
  const bar = document.getElementById('search-bar');
  if (!bar) return;
  bar.classList.toggle('open');
  if (bar.classList.contains('open')) bar.querySelector('.search-input')?.focus();
}

/* ── Cart ── */
function openCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  drawer?.classList.add('open');
  overlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const countEl    = document.getElementById('cart-drawer-count');
    const badgeEl    = document.getElementById('cart-count-badge');
    const itemsEl    = document.getElementById('cart-drawer-items');
    const footerEl   = document.getElementById('cart-drawer-footer');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (countEl) countEl.textContent = cart.item_count;
    if (badgeEl) {
      badgeEl.textContent = cart.item_count;
      badgeEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (cart.item_count === 0) {
      if (itemsEl) itemsEl.innerHTML = `
        <div class="cart-empty-state">
          <div class="cart-empty-icon">🐾</div>
          <p class="cart-empty-text">Your cart is empty</p>
          <a href="/collections/all" class="btn btn-primary" onclick="closeCart()">Start Shopping</a>
        </div>`;
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-drawer-item" id="drawer-item-${item.key}">
          <img class="cart-drawer-img"
            src="${item.image ? item.image.replace('.jpg','_120x120.jpg') : ''}"
            alt="${escHtml(item.title)}"
            onerror="this.style.display='none'">
          <div class="cart-drawer-info">
            <a href="${item.url}" class="cart-drawer-name">${escHtml(item.product_title)}</a>
            <div class="cart-drawer-price">${formatMoney(item.final_price)}</div>
            <button class="cart-drawer-remove" onclick="removeCartItem('${item.key}')">Remove</button>
          </div>
        </div>
      `).join('');
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footerEl) footerEl.style.display = 'block';

  } catch (err) { console.error('Cart refresh error:', err); }
}

async function removeCartItem(key) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    refreshCartDrawer();
  } catch (err) { console.error(err); }
}

async function quickAddToCart(btn) {
  const variantId = btn.dataset.variantId;
  if (!variantId) return;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error('Failed');
    btn.textContent = '✓ Added!';
    btn.classList.add('added');
    updateCartCount();
    openCart();
    setTimeout(() => {
      btn.textContent = 'Quick Add to Cart';
      btn.classList.remove('added');
      btn.disabled = false;
    }, 1800);
  } catch (err) {
    btn.textContent = 'Try again';
    btn.disabled = false;
  }
}

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cart-count-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    const drawerCount = document.getElementById('cart-drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count;
  } catch (err) { console.error(err); }
}

/* ── Product filters ── */
function initProductFilters() {
  const bar = document.getElementById('filter-bar');
  if (!bar) return;
}

function filterProducts(tag, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  document.querySelectorAll('.p-card').forEach(card => {
    if (tag === 'all') {
      card.style.display = '';
    } else {
      const tags = (card.dataset.tags || '').toLowerCase();
      card.style.display = tags.includes(tag.toLowerCase()) ? '' : 'none';
    }
  });
}

/* ── Scroll-triggered fade-up ── */
function initFadeObserver() {
  const els = document.querySelectorAll('.fade-up, .fade-in');
  if (!els.length) return;

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.style.animationPlayState = 'running'; obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(el => {
      el.style.animationPlayState = 'paused';
      obs.observe(el);
    });
  } else {
    els.forEach(el => el.style.animationPlayState = 'running');
  }
}

/* ── Cart drawer init ── */
function initCart() {
  if (window.shopData) updateCartCount();
}

/* ── Helpers ── */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function escHtml(str) {
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* expose to inline onclick handlers */
window.openCart          = openCart;
window.closeCart         = closeCart;
window.quickAddToCart    = quickAddToCart;
window.filterProducts    = filterProducts;
window.toggleSearch      = toggleSearch;
window.toggleMobileMenu  = toggleMobileMenu;
window.removeCartItem    = removeCartItem;
window.updateCartCount   = updateCartCount;
